export const AUTH_TOKEN_COOKIE = "yoho_web_auth_token"
export const AUTH_PROVIDER_COOKIE = "yoho_web_auth_provider"
export const AUTH_SESSION_ENDPOINT = "/api/auth/session"
export const AUTH_LOGOUT_ENDPOINT = "/api/auth/logout"

export const AUTH_COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60

export const AUTH_PROVIDERS = ["apple", "google", "sms", "whatsapp"] as const

export type AuthProviderName = (typeof AUTH_PROVIDERS)[number]

export function isAuthProviderName(
  value: string | null | undefined
): value is AuthProviderName {
  return !!value && AUTH_PROVIDERS.includes(value as AuthProviderName)
}
